import './CoolStuff.scss';
// import * as unicornSvg from './unicornSvg.svg';
import { CoolStuffActionFeature } from './CoolStuffActionFeature';
class CoolStuffController {
    static $inject = ['$scope'];
    constructor($scope) {
        'ngInject';
        this.$scope = $scope;
    }
    selectAnimation(rand) {
        switch (rand) {
            case 1:
                return 'animation-bottom-left';
            case 2:
                return 'animation-bottom-right';
            case 3:
                return 'animation-top-left';
            case 4:
                return 'animation-top-right';
            case 5:
                return 'animation-appear-bottom';
            case 6:
                return 'animation-appear-top';
            default:
                return 'animation-bottom-left';
        }
    }
    makeAnimation(chance = 0) {
        const selectAnimation = Math.floor(Math.random() * 6 + 1);
        const percentage = Math.floor(Math.random() * 100 + 1);
        if (percentage <= chance) {
            const img = document.createElement('img');
            img.src =
                'https://uploads.codesandbox.io/uploads/user/b664cc48-35d4-4c7d-924f-43714f6aad1c/RJJ6-Unicorn.svg';
            img.width = 100;
            img.height = 100;
            img.classList.add('make-effect', this.selectAnimation(selectAnimation));
            const wrapper = document.getElementById('cool-stuff-wrapper');
            const removeEl = (event) => {
                wrapper && wrapper.removeChild(img);
                img.removeEventListener('animationend', removeEl);
            };
            img.addEventListener('animationend', removeEl);
            wrapper && wrapper.appendChild(img);
        }
    }
    async $onInit() {
        const percentChance = Number(await CoolStuffActionFeature.coolStuffActionApplicationEnabled()) || 0;
        setTimeout(() => {
            if (!CoolStuffController.hasInitiated) {
                this.makeAnimation(percentChance);
                CoolStuffController.hasInitiated = true;
            }
        }, 200);
        const keyPressListener = (event) => {
            const { keyCode, ctrlKey, shiftKey } = event;
            if (keyCode === 85 && ctrlKey && shiftKey) {
                this.makeAnimation(100);
            }
        };
        document.addEventListener('keydown', keyPressListener);
        this.$scope.$on('$destroy', () => {
            CoolStuffController.hasInitiated = false;
            document.removeEventListener('keydown', keyPressListener);
        });
    }
}
CoolStuffController.$inject = ['$scope'];
export const CoolStuffComponent = {
    controller: CoolStuffController,
    controllerAs: '$ctrl',
    template: '<span id="cool-stuff-wrapper"></span>',
};
